import { CLienteAPi } from "../client_api";

//delUsuarios
export class peticion_Usuarios_Borrar {
    ConexionIacpos: number;
    clienteAPI: CLienteAPi;
    pkId: string;
}